import { render } from "./TopBar.vue?vue&type=template&id=048f196d&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=048f196d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-048f196d"

export default script